/** Same opacity the Porsche Design System applies to disabled form labels and descriptions. */
export const alphaDisabled = 0.4
